import { useState } from "react";
import { DateRange } from "react-date-range";
import moment from "moment";

const S2LicenseFilter = ({ onFilter }) => {
  const [period, setPeriod] = useState([
    {
      startDate: null,
      endDate: new Date(""),
      key: "selection",
    },
  ]);

  const handleSubmit = () => {
    let start_date = "";
    let end_date = "";

    if (period[0].startDate !== null) {
      start_date = moment(period[0].startDate).format("MM-DD-yyyy");
      end_date = moment(period[0].endDate).format("MM-DD-yyyy");
    }

    onFilter(start_date, end_date);
  };

  return (
    <form className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <label className="form-label">Date Created</label>
          <DateRange
            startDatePlaceholder="Start Date"
            endDatePlaceholder="End Date"
            editableDateInputs={false}
            moveRangeOnFirstSelection={false}
            onChange={(item) => setPeriod([item.selection])}
            ranges={period}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 mt-12">
        <div className="col-span-2">
          <button
            onClick={() => handleSubmit()}
            type="button"
            className="button button-primary"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </form>
  );
};

export default S2LicenseFilter;
